<template>
  <div v-if="cuponsAtivos && $store.state.carrinho.cupomDesconto === 0">
    <form class="cupom" @submit.prevent="aplicaCupom">
      <input placeholder="Cupom desconto" v-model="nomeCupomDesconto" />
      <button id="btn-cupom" type="submit">OK</button>
    </form>
    </div>
    <div v-else-if="$store.state.carrinho.dadosCupomDesconto">
      {{$store.state.carrinho.dadosCupomDesconto.NomeCupom}} - R${{$store.state.carrinho.dadosCupomDesconto.ValorCupom}} <span v-if="$store.state.menu.finalizacaoPedido !== true" style="cursor:pointer" @click="removeCupom"><i class="fas fa-times"></i></span>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { db } from '@/firebase.js'
export default {
  name: 'Cupom',
  data: function () {
    return {
      nomeCupomDesconto: null,
      cuponsAtivos: false
    }
  },
  created () {
    this.verificaCupomAtivo()
  },
  methods: {
    ...mapActions('carrinho', ['cupomDesconto', 'dadosCupomDesconto', 'diminuiTotal', 'somaTotal', 'destroiCupom']),
    ...mapActions('menu', ['toggleMenu']),
    ...mapActions('configuracoes', ['loading']),
    removeCupom () {
      this.somaTotal(this.$store.state.carrinho.cupomDesconto)
      this.destroiCupom()
      this.nomeCupomDesconto = null
      setTimeout(() => this.toggleMenu(true), 1)
    },
    verificaCupomAtivo () {
      db.collection('Cupom').where('Ativo', '==', true).limit(1).get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          this.cuponsAtivos = true
        }
      })
    },
    async aplicaCupom () {
      var total = this.$store.state.carrinho.total
      if (this.$store.state.carrinho.cupomDesconto === 0) {
        await db.collection('Cupom').where('NomeCupom', '==', this.nomeCupomDesconto).limit(1).get().then(async (querySnapshotCupom) => {
          if (!querySnapshotCupom.empty) {
            querySnapshotCupom.forEach(async (doc) => {
              if (this.$store.state.usuario.usuario != null) {
                await db.collection('Clientes').doc(this.$store.state.usuario.usuario.Email).collection('Cupons').where('id', '==', doc.id).limit(1).get().then(async (querySnapshotUsuario) => {
                  if (querySnapshotUsuario.empty) {
                    this.validarMinimoCompra(doc.data(), total)
                  } else {
                    this.$fire({
                      title: 'Erro ao aplicar cupom',
                      text: 'Cupom já utilizado',
                      type: 'error'
                    }).then(r => {
                      setTimeout(() => this.toggleMenu(true), 1)
                    })
                  }
                })
              } else {
                this.validarMinimoCompra(doc.data(), total)
              }
            })
          } else {
            this.$fire({
              title: 'Erro ao aplicar cupom',
              html: '<p>O cupom informado não existe</p>',
              type: 'error'
            }).then(r => {
              setTimeout(() => this.toggleMenu(true), 1)
            })
          }
        })
      }
    },
    async validarMinimoCompra (cupom, total) {
      if (total >= cupom.ValorMinimoCompra) {
        if (cupom.QtdCupom > 0) {
          this.cupomDesconto(cupom.ValorCupom)
          this.dadosCupomDesconto(cupom)
          this.diminuiTotal(cupom.ValorCupom)
        } else {
          this.$fire({
            title: 'Erro ao aplicar cupom',
            html: '<p>O cupom <b>' + cupom.NomeCupom + '</b> está esgotado</p>',
            type: 'error'
          }).then(r => {
            setTimeout(() => this.toggleMenu(true), 1)
          })
        }
      } else {
        this.$fire({
          title: 'Erro ao aplicar cupom',
          text: 'O valor mínimo da compra para utilizar o cupom é de R$' + cupom.ValorMinimoCompra,
          type: 'error'
        }).then(r => {
          setTimeout(() => this.toggleMenu(true), 1)
        })
      }
    }
  }
}
</script>
<style scoped>
  button {
    height: 2.5em;
  }
  .cupom {
    display: flex;
    flex-direction: row;
    align-items: flex-start
  }
  #btn-cupom {
    margin: auto 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cupom.vue